import React from "react";
import "./Footer.css"; // Import the CSS file

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      Copyright © 1996 – {currentYear} Air Products and Chemicals, Inc. All
      Rights Reserved.
    </footer>
  );
};

export default Footer;
